import React from 'react';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';
import { Dropdown } from 'semantic-ui-react';

class Customer extends React.Component {

  state = {
    customerOption: [],
  }

  componentDidMount() {
    this.getCustomerType();
  }

  getCustomerType() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Customer type'
    })
    $.ajax({
      type: 'POST',
      url: Server() + 'addmenu/branddetails/getallbrands.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
        try {
          data = JSON.parse(data);
          context.setAllBrand(data);
        } catch (e) {
          console.log(e);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  setAllBrand(data) {
    let context = this;
    var customer = [];
    data.map((y) => {
      let text = y.id+"-->"+y.brand_name;
      customer.push({key: text, text: text, value: y.id});
    });
    if (this.props.type == 'all') {
      customer.push({key: 'ALL', text: 'ALL', value: 'ALL'});
    }
    this.setState({
      brandOption: customer,
      brands: data
    });
    this.getBranchs();
  }

  brand = (f, { value }) => {
    this.setState({ brand: value });
    this.props.update(value, this.state.brands);
  }
  render() {
    return (
      <div>
        <Dropdown placeholder='Brand' style={{ borderColor: '#5A9CBB' }}
         search selection onChange={this.brand}
         options={this.state.brandOption} value={this.state.brand} />
      </div>
    );
  }
}

export default Customer;
